function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * @description This service provides a listener and store for sdkconfig overrides that we don't want exposed to clients
 */ import { sdkLogger } from '../../logger';
import { JsonUtils } from '../../utils/json-utils';
var overrides = {
    yospace: {},
    multiPlayerCsai: {
        staticOverride: false
    },
    isSeekableDuringAds: false,
    isForcedUnitedStatesIpAddress: false,
    nielsenDtvrOverride: undefined,
    deviceModelOverride: '',
    forceSlePreroll: 'Default',
    adsIntervalBeforeNextAdSeconds: undefined,
    ps5EsvmOverride: undefined,
    shouldDisableHdcpTesting: false,
    securityBasedBandwidthCapDisable: undefined,
    testDeviceCapabilities: undefined,
    bypassShakaBitrateLimit: false
};
export function dangerouslyOverrideAdInsertionType(adInsertionType) {
    sdkLogger.warn("Setting AdInsertionType SdkConfig overrides");
    overrides.adInsertionType = adInsertionType;
}
export function dangerouslySetYospaceEnvironment(environment) {
    sdkLogger.warn("Setting YospaceEnvironment SdkConfig overrides");
    overrides.yospace.environment = environment;
}
export function dangerouslySetMultiPlayerCsaiStatic(shouldOverrideWithStatic) {
    sdkLogger.warn("Setting MultiPlayerCsai overrides");
    overrides.multiPlayerCsai.staticOverride = shouldOverrideWithStatic;
}
export function dangerouslySetUnitedStatesIpAddress(isForcedUnitedStatesIpAddress) {
    sdkLogger.warn("Setting US IP override");
    overrides.isForcedUnitedStatesIpAddress = isForcedUnitedStatesIpAddress;
}
export function dangerouslySetShakaConfiguration(shakaOverrides) {
    sdkLogger.warn("Setting Shaka Configuration");
    overrides.shaka = shakaOverrides;
}
export function dangerouslySetUncompiledShaka(uncompiledShaka) {
    sdkLogger.warn("Setting uncompiled shaka Configuration");
    overrides.uncompiledShaka = uncompiledShaka;
}
export function dangerouslySetNielsenDtvrOverride(nielsenDtvrOverride) {
    sdkLogger.warn("Setting Nielsen DTVR Override to: ".concat(nielsenDtvrOverride));
    overrides.nielsenDtvrOverride = nielsenDtvrOverride;
}
export function dangerouslySetCoordinatedBitrateCap(coordinatedBitrateCapOverride) {
    sdkLogger.warn("Setting coordinatedBitrateCapOverride: interval: ".concat(coordinatedBitrateCapOverride === null || coordinatedBitrateCapOverride === void 0 ? void 0 : coordinatedBitrateCapOverride.pollingTimeout, " cap: ").concat(coordinatedBitrateCapOverride === null || coordinatedBitrateCapOverride === void 0 ? void 0 : coordinatedBitrateCapOverride.bitrateCap, " allowAnyAssetType: ").concat(coordinatedBitrateCapOverride === null || coordinatedBitrateCapOverride === void 0 ? void 0 : coordinatedBitrateCapOverride.allowAnyAssetType));
    overrides.coordinatedBitrateCap = coordinatedBitrateCapOverride;
}
export function dangerouslySetDeviceModel(deviceModel) {
    sdkLogger.warn('Setting Override for Device Model, new value: "'.concat(deviceModel, '"'));
    overrides.deviceModelOverride = deviceModel;
}
export function dangerouslyForceSlePreroll(forceSlePreroll) {
    sdkLogger.warn("Setting Force SLE Preroll Override: ".concat(forceSlePreroll));
    overrides.forceSlePreroll = forceSlePreroll;
}
export function dangerouslySetCompatibleStreamPropertyGroup(compatibleGroup) {
    sdkLogger.warn("Setting Compatible Stream Property Group: ".concat(JsonUtils.stringify(compatibleGroup)));
    overrides.compatibleStreamPropertyGroup = compatibleGroup;
}
export function dangerouslySetAdsIntervalBeforeNextAdSeconds(seconds) {
    sdkLogger.warn("Setting Interval before next Ads: ".concat(seconds));
    overrides.adsIntervalBeforeNextAdSeconds = seconds;
}
export function dangerouslyOverridePs5Esvm(enabled) {
    sdkLogger.warn("Setting PS5 ESVM override to ".concat(enabled));
    overrides.ps5EsvmOverride = enabled;
}
export function dangerouslyOverrideSecurityBandwidthCap(disabled) {
    sdkLogger.warn("Setting Security Manager Bandwidth Cap Disable to ".concat(disabled));
    overrides.securityBasedBandwidthCapDisable = disabled;
}
export function dangerouslyOverrideMetalistEndpoint(endpoint) {
    if (endpoint) {
        sdkLogger.warn("Setting Metalist endpoint override to ".concat(endpoint));
    }
    overrides.metalistEndpointOverride = endpoint;
}
export function dangerouslyOverrideLiveActionsCustomEvents(liveActionsTestCustomEvents) {
    if (liveActionsTestCustomEvents) {
        sdkLogger.warn("Setting live actions test custom events override to ".concat(liveActionsTestCustomEvents));
    }
    overrides.liveActionsTestCustomEvents = liveActionsTestCustomEvents;
}
export function dangerouslyOverrideShouldDisableHdcpTesting(shouldDisableHdcpTesting) {
    overrides.shouldDisableHdcpTesting = shouldDisableHdcpTesting;
}
export function dangerouslyOverrideDeviceCapabilities(deviceCapabilities) {
    overrides.testDeviceCapabilities = deviceCapabilities;
}
export var TestingOverrides = /*#__PURE__*/ function() {
    "use strict";
    function TestingOverrides() {
        _class_call_check(this, TestingOverrides);
    }
    _create_class(TestingOverrides, null, [
        {
            key: "adInsertionOverride",
            get: function get() {
                return overrides.adInsertionType;
            }
        },
        {
            key: "yospaceOverride",
            get: function get() {
                return overrides.yospace;
            }
        },
        {
            key: "multiPlayerCsaiOverride",
            get: function get() {
                return overrides.multiPlayerCsai;
            }
        },
        {
            key: "isForcedUnitedStatesIpAddress",
            get: function get() {
                return overrides.isForcedUnitedStatesIpAddress;
            }
        },
        {
            key: "shakaOverrides",
            get: function get() {
                return overrides.shaka;
            }
        },
        {
            key: "uncompiledShaka",
            get: function get() {
                return overrides.uncompiledShaka;
            }
        },
        {
            key: "nielsenDtvrOverride",
            get: function get() {
                return overrides.nielsenDtvrOverride;
            }
        },
        {
            key: "deviceModelOverride",
            get: function get() {
                return overrides.deviceModelOverride;
            }
        },
        {
            key: "forceSlePreroll",
            get: function get() {
                return overrides.forceSlePreroll;
            }
        },
        {
            key: "coordinatedBitrateCap",
            get: function get() {
                return overrides.coordinatedBitrateCap;
            }
        },
        {
            key: "compatibleStreamPropertyGroup",
            get: function get() {
                return overrides.compatibleStreamPropertyGroup;
            }
        },
        {
            key: "adsIntervalBeforeNextAdSeconds",
            get: function get() {
                return overrides.adsIntervalBeforeNextAdSeconds;
            }
        },
        {
            key: "ps5EsvmOverride",
            get: function get() {
                return overrides.ps5EsvmOverride;
            }
        },
        {
            key: "metalistEndpointOverride",
            get: function get() {
                return overrides.metalistEndpointOverride;
            }
        },
        {
            key: "liveActionsTestCustomEvents",
            get: function get() {
                return overrides.liveActionsTestCustomEvents;
            }
        },
        {
            key: "shouldDisableHdcpTesting",
            get: function get() {
                return overrides.shouldDisableHdcpTesting;
            }
        },
        {
            key: "securityBasedBandwidthCapDisable",
            get: function get() {
                return overrides.securityBasedBandwidthCapDisable;
            }
        },
        {
            key: "testDeviceCapabilities",
            get: function get() {
                return overrides.testDeviceCapabilities;
            }
        },
        {
            key: "bypassShakaBitrateLimit",
            get: function get() {
                return overrides.bypassShakaBitrateLimit;
            }
        }
    ]);
    return TestingOverrides;
}();

//# sourceMappingURL=testing-overrides.js.map